module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.9804/images/default-share-image.png"